import { useEffect } from 'react'
import { useAuth } from '$features/auth/hooks/use-auth'

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
  }
}

/**
 * Pushes the authenticated user's id to the GTM dataLayer as `user_id`
 * so GA4 can associate hits with the logged-in user. Only runs in production
 * when GTM is loaded.
 */
export function GtagUserIdSync() {
  const { user, isLoggedIn } = useAuth()

  useEffect(() => {
    if (!import.meta.env.PROD) {return}

    if (isLoggedIn && user?.id != null) {
      window.dataLayer = window.dataLayer ?? []
      window.dataLayer.push({ user_id: String(user.id) })
    }
  }, [isLoggedIn, user?.id])

  return null
}
